export const emailForConfirmProvideLaterStepSelector = () => {
  return 'support@swag.com';
};